<template lang="pug">
modal.checkbox-settings-modal(
  :close-button-label='$t("button.cancel")'
  :no-footer='true'
  :title='$t("modal.image_settings.title")'
  @closed='onClose'
  ref='modal'
  size='sm'
)
  .col-12(v-if='element')
    upload-area(:key='key' @change='loadFile')
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';
import UploadArea from '@/ui/molecules/ImageUploadArea.vue';

export default {
  components: {
    Modal,
    Icon,
    UploadArea,
  },
  data() {
    return {
      element: {},
      key: 1,
    };
  },
  methods: {
    async loadFile(file) {
      const imageBase64 = file.image;
      const imageData = await this.getImageData(imageBase64);
      this.$set(this.element, 'key', this.element.key + 1);
      this.$set(this.element, 'value', file.blob);
      // this.$set(this.element, 'image', '');
      this.$set(this.element, 'image', imageData);
      // this.$set(this.element, 'width', imageData.width);
      // this.$set(this.element, 'height', imageData.height);
      this.$emit('settings', this.element);
      this.$refs.modal.close();
    },
    async getImageData(base64) {
      const result = await new Promise((resolve) => {
        const image = new Image();
        image.src = base64;
        image.onload = () => resolve(image);
      });
      return result;
    },
    onClose() {
      this.key += 1;
    },
  },
};
</script>
<style lang="stylus">
.checkbox-settings-modal
  .form-check.form-switch
    .form-check-label
      margin: .2rem 0 0 .5rem
</style>
